import {
  ActionCreatorWithPayload,
  ActionsCreatorCombined,
  AnyObject,
  flow,
  set,
} from '@binotel-frontend/bnt-common-components';
import {ApiActions} from '@binotel-frontend/bnt-common-components';
import {on, ReducerTypes} from '@ngrx/store';
import {status} from '@binotel-frontend/bnt-common-components';

export const getApiActionReducersPaginated =
  <State extends AnyObject>() =>
  <
    Payload extends AnyObject,
    Keys extends keyof State & string,
    RequestPayload extends AnyObject,
  >(
    action: ApiActions<Payload, RequestPayload>,
    storeDataKey: Keys,
    loadingStatus?: Keys
  ): ReducerTypes<State, ActionsCreatorCombined<Payload>[]>[] => {
    const loadingStatusProperty =
      loadingStatus ?? `${storeDataKey as string}LoadingStatus`;
    const paginationProperty = `${storeDataKey as string}Pagination`;

    return [
      on(action.requested as ActionsCreatorCombined<Payload>, (state) =>
        set(loadingStatusProperty, status.loading, state)
      ),
      on(
        action.succeeded as ActionCreatorWithPayload<Payload>,
        (state, {payload, pagination}) =>
          flow(state)(
            set(loadingStatusProperty, status.loaded),
            set(storeDataKey as string, payload),
            set(paginationProperty, pagination)
          )
      ),
      on(action.failed, (state, {error}) =>
        set(loadingStatusProperty, status.error(error), state)
      ),
    ];
  };
